import { graphql } from '@/gql';
import type { PaginatedWelcomeTextInboxCallerTypeResponse } from '@/models/welcomeTextInboxCaller';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { QueryWelcomeTextInboxCallersArgs } from '../../gql/graphql';

export const fetchWelcomeTextInboxCallers = async ({
  pagination,
  statusGroup,
  callerName,
  phoneNumber,
  messageText,
}: QueryWelcomeTextInboxCallersArgs): Promise<PaginatedWelcomeTextInboxCallerTypeResponse> => {
  const response = await queryExecute({
    variables: {
      pagination,
      statusGroup,
      callerName,
      phoneNumber,
      messageText,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query WelcomeTextInboxCallers(
        $pagination: PaginationInputType
        $statusGroup: WelcomeTextInboxCallerStatusGroup
        $callerName: String
        $phoneNumber: String
        $messageText: String
      ) {
        welcomeTextInboxCallers(pagination: $pagination, statusGroup: $statusGroup, callerName: $callerName, phoneNumber: $phoneNumber, messageText: $messageText) {
          count
          rows {
            callerId
            firstName
            lastName
            phoneNumber
            firstRideDate
            firstRideLocationType
            rideCount
            lastSmsReply
            firstReplySentiment
            firstWelcomeMessageOperatorFirstName
            status
            action
          }
        }
      }
    `),
  });

  return response.data.welcomeTextInboxCallers;
};
